export const PAGE_SIZE = 5;
export const REQUIRED_ACTIONS_ON_SCREEN_FOR_BOTTOM_PAGINATION = 2;
